export default "__VITE_ASSET__B1SPnnr5__"